import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { financialCalendarOptions } from './query-options';

import type { CalendarFilter } from './types';

/** 리스트 뷰 전용 — 무한스크롤 (pageSize=20) */
export const useFinancialCalendarInfiniteQuery = (filter: CalendarFilter) =>
  useInfiniteQuery(financialCalendarOptions.getEventList(filter));

/** 캘린더 뷰(주간/월간) 전용 — 단일 조회 (pageSize=500) */
export const useFinancialCalendarQuery = (filter: CalendarFilter) =>
  useQuery(financialCalendarOptions.getCalendarEvents(filter));

/** TRAD-2071 — 날짜별 {highCount,totalCount} 집계("전체 M건 보기" 고지). importance 무관, /events와 별도 엔드포인트. */
export const useFinancialCalendarDailyCountsQuery = (filter: CalendarFilter) =>
  useQuery(financialCalendarOptions.getDailyCounts(filter));
